
import { Placement } from '@post-office/placements-frontend/rovo-chat-input-side-panel';
export default Placement;
